import { useState, useCallback, useEffect } from "react";
import Cookies from 'universal-cookie';
const cookies = new Cookies();

// Utility functions to get and set cookies


export function useFingerprintPro() {
  const [fingerprint, setFingerprint] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  const COOKIE_NAME = "fingerprint_id";
  let fingerPrintData = "";

  const fetchFingerprint = useCallback(async () => {
    setLoading(true);
    setError(null);
    try {
      if (typeof window.getFingerprint !== "function") {
        setError("getFingerprint function not available");
        setLoading(false);
        return;
      }

      const fp = await window.getFingerprint('Vmct-3WbzzgJOnMPqDRxvzItpagcQiy49h2dkmVCAps');
      setFingerprint(fp);
      if (fp.success) {
        fingerPrintData = fp;
        const expires = new Date();
        expires.setDate(expires.getDate() + 7);
        cookies.set(COOKIE_NAME, fp.visitorId, { path: '/', expires });
      }
    } catch (err) {
      setError(typeof err === "string" ? err : err instanceof Error ? err.message : "Unknown error");
    } finally {
      setLoading(false);
    }
  }, []);
  
  return { fingerprint, loading, error, fingerPrintData, refetch: fetchFingerprint };
}
